import { useContext, useEffect, useState } from "react";

import { Button } from "@vimeo/iris/components";

import EmbedInEmailContext from "../../contexts/embedInEmailContext";
import { isContentBlockContext } from "../../sessionStorage";
import { EventName, sendAnalyticsEvent } from "../../analytics/common";

interface Props {
    imgUrl: string;
    title: string;
}

export function CompleteAssetCreation(props: Props) {
    const [embedInEmailContextState] = useContext(EmbedInEmailContext);
    const [showEmbedNow, setShowEmbedNow] = useState(false);

    // Embedding the content using the blocksdk will not work when the UI
    // is served using its dev server. Instead, use the API server to serve
    // the UI by setting `REDIRECT_UI_TO_LOCALHOST` to `false` in the API folder.
    const shouldDisableEmbedButton =
        window.location.host.includes("localhost:3000");

    useEffect(() => {
        const showEmbedNow = isContentBlockContext();
        setShowEmbedNow(showEmbedNow);
    }, []);

    function embedAsset() {
        if (!embedInEmailContextState.asset?.content) {
            throw new Error("Content Builder asset details is required");
        }

        window.blockSdk.setContent(
            embedInEmailContextState.asset.content,
            () => {
                sendAnalyticsEvent(EventName.embed, {
                    name: "success_embed",
                    asset_type: embedInEmailContextState.selectedImgType,
                    location: embedInEmailContextState.source,
                    video_id: embedInEmailContextState.videoId,
                    cta: "embed_in_email",
                });
            }
        );
    }

    return (
        <div className="slds-grid slds-grid_vertical slds-align_absolute-center">
            <div className="slds-col_padded slds-m-bottom_small">
                <img
                    src={props.imgUrl}
                    style={{
                        marginLeft: "20%",
                        marginRight: "20%",
                        width: "60%",
                        maxHeight: "50%",
                    }}
                    alt={props.title}
                />
            </div>

            {!showEmbedNow && (
                <div
                    key="1"
                    className="slds-col_padded slds-m-bottom_small slds-text-heading_small"
                >
                    Your asset was successfully ported to Content Builder!
                </div>
            )}
            {showEmbedNow && [
                <div
                    key="1"
                    className="slds-col_padded slds-m-bottom_small slds-text-heading_small"
                >
                    Ready to embed!
                </div>,
                <div key="2" className="slds-col_padded slds-m-bottom_small">
                    <Button
                        format="primary"
                        style={{ width: "200px" }}
                        onClick={embedAsset}
                        disabled={shouldDisableEmbedButton}
                    >
                        Embed in email
                    </Button>
                </div>,
            ]}
        </div>
    );
}
